import { axiosBff, AxiosResponse } from '@/plugins/axios';
import {
	InscriptionModel,
	PasswordModel,
	EmailModel,
	NewMotDePasseModel,
	LoginModel
} from '@/services/compte/types';
import { User } from '@/types';
import { buildUrlWithSiret } from '@/functions/buildUrlWithSiret';

export function creerCompte(userType: string, payload: InscriptionModel ): Promise<AxiosResponse> {
	return axiosBff.post(`/api/inscription/${userType}`, payload);
}

export function validateUser(token: string): Promise<AxiosResponse> {
	return axiosBff.get(`/api/validate-user/${token}`);
}

export function validateCgu(): Promise<AxiosResponse> {
	return axiosBff.post('/api/validate/cgu');
}

export function forgottenPassword(email: string): Promise<AxiosResponse> {
	return axiosBff.get(`/api/forgotten-password/${email}`);
}

export function resetPassword(token: string, payload: PasswordModel ): Promise<AxiosResponse> {
	return axiosBff.post(`/api/reset-password/${token}`, payload);
}

export function checkToken(token: string): Promise<AxiosResponse> {
	return axiosBff.get(`/api/check-token/${token}`);
}

export function getMyUser(): Promise<AxiosResponse<User>> {
	const url = buildUrlWithSiret('/api/my-user');

	return axiosBff.get(url, {
		skipInstanceNotification: true
	});
}
export function modifierMotDePasse(payload: NewMotDePasseModel): Promise<AxiosResponse> {
	return axiosBff.post('/api/modifier-mot-de-passe', payload);
}

export function sendEmailValidationNewEmail(payload: EmailModel): Promise<AxiosResponse> {
	return axiosBff.post('/api/send-email-validation-new-email', payload);
}

export function validateNewEmail(token: string, payload: EmailModel): Promise<AxiosResponse> {
	return axiosBff.post(`/api/validate-new-email/${token}`, payload);
}

export function connect(payload: Partial<LoginModel>): Promise<AxiosResponse> {
	return axiosBff.post('/bff/login', payload);
}

export function inscriptionCgu(token: string): Promise<AxiosResponse> {

	return axiosBff.post('/fc/inscription', null, {
		headers: {
			Authorization: token
		}
	});
}

export function disconnect(): Promise<AxiosResponse> {
	// pas de notif ici, c'est le logout qui gere le cas
	return axiosBff.post('/bff/logout', undefined, { skipInstanceNotification: true });
}
